<template>
  <component :openPanel="openPanel" :is="getPanel" :isValid="isValid" @setRules="setRules" :answer="answer" :invalid="invalid" :isAnswered="isAnswered" :submitAnswer="submitAnswer" />
</template>

<script>
    import { mapGetters } from 'vuex';
    import api from '../store/api';

    //Panels
    import Privacy from "./panels/Privacy";
    import Topics from "./panels/Topics";
    import Features from "./panels/Features";
    import Demographic from "./panels/Demographic";
    import Format from "./panels/Format";
    import Methods from "./panels/Methods";
    import Specialization from "./panels/Specialization"
    import Zipcode from "./panels/Zipcode";
    import AdjustDistance from "./panels/AdjustDistance";
    import TravelDistance from "./panels/TravelDistance";
    import LoadingMessage from "./panels/LoadingMessage";


    export default {
        name: 'Panels',
        components: {
            LoadingMessage,
            Privacy,
            Topics,
            Features,
            Demographic,
            Format,
            Methods,
            Specialization,
            Zipcode,
            AdjustDistance,
            TravelDistance
        },
        props: {
            user: {
                type: Object
            },
            type: {
                type: String
            },
            answerDefault: {
                type: [String, Boolean, Number, Array]
            },
            customValidation: {
                default: false
            }
        },
        validators: {
            min(value, min) {
                return (value || '').length >= min;
            },
            max(value, max) {
                return (value || '').length <= max;
            },
            email(value) {
                return /(.+)@(.+){2,}\.(.+){2,}/.test(value);
            },
            required(value) {
                return value !== null;
            },
            dateBetween(value, min, max) {
                return true; // TODO
            },
            regex(value, pattern) {
                var regex = new RegExp(pattern);
                return regex.test(value);
            },
            birthday(value) {
                if (safari) {
                    return /^(\d{1,2})-(\d{1,2})-(\d{4})$/.test(value);
                }
                return /^(\d{4})-(\d{1,2})-(\d{1,2})$/.test(value);
            }
        },
        computed: {
            ...mapGetters([
                'getPanel'
            ]),
        },
        watch: {
            answer: {
                handler: function (newVal) {
                    for (let [name, param] of Object.entries(newVal)) {
                        this.setAnswered(name);

                        if (typeof this.rules[name] != "undefined") {
                            this.validate(param, this.rules[name], name)
                        }
                    }
                },
                deep: true,
            },
            loading: function(loading) {
                if (loading) {
                    this.openPanel('LoadingMessage')
                }
            }
        },
        data() {
            return {
                loading: false,
                currentComponent: null,
                answer: {
                    topics: [],
                    features: [],
                    format: [],
                    coachAge: null,
                    date: null,
                    age: null,
                    gender: null,
                    birthday: null,
                    methods: [],
                    specializations: [],
                    toggleLive: null,
                    zipcode: null,
                    distance: 25,
                    blog_id: cfpluginvars.blog_id,
                    language: null
                },
                toggle: null,
                toggleLive: null,
                safari: false,
                invalid: {},
                rules: {},
                isAnswered: {}
            }
        },
        created() {
          for (let [name, param] of Object.entries(this.answer)) {
                this.$set(this.invalid, name, {});
            }
        },
        methods: {
            isValid(name) {
                return Object.keys(this.invalid[name]).length === 0;
            },
            setRules(rules) {
                this.rules = JSON.parse(JSON.stringify(rules));
            },
            setAnswered(name) {
                if(this.answer[name] != null && this.answer[name].length > 0) {
                    this.isAnswered[name] = true;
                } else {
                    this.isAnswered[name] = false;
                }
            },

            /**
             * Perform validation and set possible errors
             * @param mixed value
             */
            validate: function(value, rules, name) {
                var validators = this.$options.validators;

                for (const [ruleKey, ruleVal] of Object.entries(rules)) {
                    var valid = false;

                    if (! (ruleKey in validators)) {
                        console.warn('Validation ', ruleKey, ' doesn\'t exist in ', this.id);
                        return;
                    }

                    // Dynamically call method
                    valid = validators[ruleKey].call(this, value, ruleVal);
                    
                    // Modify `invalid` object
                    if (valid) {
                        this.$delete(this.invalid[name], ruleKey)
                    } else {
                        this.$set(this.invalid[name], ruleKey, ruleVal);
                    }
                }
            },
            openPanel: function(panelName) {
              this.$store.dispatch(
                  'SetPanel',
                  panelName
              )
            },
            submitAnswer() {
              this.loading = true;

              api.post('questionary/match', this.answer)
                   .then(response => {
                       if (response.data.coachesFound) {
                         window.location.href = '/jouw-coaches/?selectionUuid=' + response.data.selectionUuid + '&secret=' + response.data.secret;
                       } else {
                          this.openPanel("AdjustDistance");
                       }
                       this.loading = false;
                   })
                   .catch(function (error) {
                      this.openPanel("Zipcode");
                      this.loading = false;
                   });
            }
        }
    }
</script>